export default __webpack_public_path__ + "static/spot-immunity-ce260ee89c3a3c86b065de6eb99d5f69.jpg";